import Constants from '@usas/ui-web/utils/Constants';
import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOrgUnitAthleteEntryInfoData from './GetOrgUnitAthleteEntryInfoData';

export const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  orgUnitAthleteEntryId: Constants.DEFAULT_ID
};

const OrgUnitAthleteEntryInfoData = {
  getOrgUnitAthleteEntryInfoData,
  INITIAL_STATE
};

export default OrgUnitAthleteEntryInfoData;